import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Tag } from 'foundations-components/transitional/components/Tag';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { useGetBreadcrumbsByUrl } from '../../../hooks/useGetBreadcrumbsByUrl';
import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import { useViewport } from 'developer-docs-shared-components/hooks/useViewport';
import styled from 'styled-components';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import { Link } from 'foundations-components/transitional/components/Link';
import { getRouterAwarePathFromProxyUrl } from 'developer-docs-shared-components/utils/urls';
import { Text } from 'foundations-components/components/Text';
import { getPageMapValueFromTagName } from '../searchHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Description = styled.div.withConfig({
  displayName: "ResultDescription__Description",
  componentId: "cnl896-0"
})(["font-size:14px;color:", ";padding-top:16px;margin-bottom:0;padding-right:40px;"], OBSIDIAN);
const StyledDescriptionWrapper = styled.div.withConfig({
  displayName: "ResultDescription__StyledDescriptionWrapper",
  componentId: "cnl896-1"
})(["display:flex;flex-direction:column;padding-right:5px;", "{flex-grow:1;}"], mediaQueries.belowTablet);
const StyledHeaderWrapper = styled.div.withConfig({
  displayName: "ResultDescription__StyledHeaderWrapper",
  componentId: "cnl896-2"
})(["display:flex;align-items:center;", "{justify-content:space-between;}a{font-weight:300;strong{font-weight:700;}}"], mediaQueries.belowTablet);
const ResultDescription = ({
  onClick,
  result
}) => {
  const {
    htmlTitle,
    title,
    htmlSnippet,
    link
  } = result;
  const {
    isBelowLaptop
  } = useViewport();
  const routerHref = getRouterAwarePathFromProxyUrl(link);
  const breadcrumbs = useGetBreadcrumbsByUrl({
    title
  }, routerHref);
  const version = getPageMapValueFromTagName(result, 'developer-docs-ui:version');
  return /*#__PURE__*/_jsxs(StyledDescriptionWrapper, {
    children: [/*#__PURE__*/_jsxs(StyledHeaderWrapper, {
      children: [/*#__PURE__*/_jsx(Link, {
        href: link,
        onClick: onClick,
        children: /*#__PURE__*/_jsx(SanitizedText, {
          body: htmlTitle
        })
      }), version && version !== 'unversioned' && /*#__PURE__*/_jsx(Tag, {
        "data-test-id": "result-description-version-tag",
        inline: true,
        marginInline: "0",
        marginInlineStart: isBelowLaptop ? '200' : '300',
        minInlineSize: "fit-content",
        children: version
      })]
    }), breadcrumbs && /*#__PURE__*/_jsx(Breadcrumbs, {
      flush: true,
      wrapLevels: true,
      children: breadcrumbs.map(({
        name
      }, i) => /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-200",
        color: "text-primary-subtle",
        children: name
      }, `${name}-${i}`))
    }), /*#__PURE__*/_jsx(Description, {
      "data-test-id": "srp-description",
      children: /*#__PURE__*/_jsx(SanitizedText, {
        body: htmlSnippet,
        formattingOptions: {
          shouldPreventAutoLinker: true
        }
      })
    })]
  });
};
export default ResultDescription;